<template>
  <div  class="assigned-list" :class="{'without_btn': !(!isTherapist && !onlyList && !isMensurationForbidden && !isPreviousDateSession)}">
    <span class="text-danger">{{errorDeleteMessage}}</span>
    <table-view
        :options="options"
        :isLoaded=isLoaded
        :isChange="isChange"
        :isTwoSearch=true
        v-on:on-search="onSearchEnter"
        v-on:on-search-skill-field="onSearchSkillField"
    >
      <div slot="id" slot-scope="props">
        <router-link
            :to="{ name: 'protocol-item', params: {clientId: clientId, protocolId: props.row.id }}">
          <div class="icon-circle icon-blue"><span v-if="!isMobile">{{'user.P' | trans}}</span></div>
        </router-link>
      </div>

      <div slot="protocols" slot-scope="props">

        <router-link
            v-if="activeProtocolList(props.row.protocol.stages).length !== 1 &&
                  !isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                  !isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                  !isPecsProtocol(props.row.protocol.teachingMethod.id) &&
                  !isCompleted(props.row) &&
                  !isNew(props.row) &&
                  !isMensurationForbidden  &&
                  !isClient &&
                  !isOnIndividualization(props.row)"
            :to="{ name: 'stage-list', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}" class="title">
           <strong>{{props.row.protocol.title}}</strong>
        </router-link>

        <router-link
            v-if="isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
            !isCompleted(props.row) && !isNew(props.row) &&
            !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
            :to="{ name: 'stage-list', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}"
            class="title">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
        <router-link class="title"  v-if="activeProtocolList(props.row.protocol.stages).length === 1 &&
                  !isCompleted(props.row) && !isNew(props.row) &&
                  !isMensurationForbidden  &&
                  !isClient &&
                  !isOnIndividualization(props.row) &&
                  (isChainProtocol(props.row.protocol.teachingMethod.id) || isShapingProtocol(props.row.protocol.teachingMethod.id) || isMandProtocol(props.row.protocol.teachingMethod.id))"
                      :to="{ name: isChainProtocol(props.row.protocol.teachingMethod.id) ? 'chain-stage-current' : isShapingProtocol(props.row.protocol.teachingMethod.id) ? 'shaping-stage-current' : 'mand-stage-current',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
        <router-link class="title"
                     v-if="activeProtocolList(props.row.protocol.stages).length === 1 &&
                     !isCompleted(props.row) && !isNew(props.row) &&
                     !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) && isUSDProtocol(props.row.protocol.teachingMethod.id)"
                     :to="{ name: 'choose-usd',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>

        <router-link class="title"  v-if="isPecsProtocol(props.row.protocol.teachingMethod.id) &&
                      !isCompleted(props.row) && !isNew(props.row) && !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
                     :to="{ name: 'pecs-stage',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>

        <router-link class="title"  v-if="isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                      !isCompleted(props.row) && !isNew(props.row) && !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
                     :to="{ name: 'pecs-stage-without-discrimination',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>

        <router-link class="title"  v-if="isPecsWithItemsProtocol(props.row.protocol.teachingMethod.id) && !isCompleted(props.row) &&
                      !isNew(props.row) && !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
                     :to="{ name: 'pecs-with-items-stage',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>

        <router-link class="title"  v-if="activeProtocolList(props.row.protocol.stages).length === 1 && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) &&
          isDTTProtocol(props.row.protocol.teachingMethod.id)"
                      :to="{ name: 'choose-stage',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
        <router-link class="title"  v-if="activeProtocolList(props.row.protocol.stages).length === 1 && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) &&
          isSimpleProtocol(props.row.protocol.teachingMethod.id)"
                     :to="{ name: 'current-stage',
                     params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
        
        
        <router-link v-if="isNew(props.row) || (!isCompleted(props.row) && !isNew(props.row) && isMensurationForbidden)  ||
                    (!isCompleted(props.row) && !isNew(props.row) && isClient) || isOnIndividualization(props.row)"
                     :to="{ name: 'protocol-item', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}" class="title">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
        <router-link v-if="isCompleted(props.row)"
                     :to="{ name: 'results', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}" class="title">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
        <!--<strong v-if="!onlyList">{{protocol.protocol.title}}<br></strong>-->
        <div>
          <dl class="term_with_descr">
            <dt>{{'protocol.protocol_goal' | trans}}:</dt>
            <dd>{{props.row.protocol.goal}}</dd>
          </dl>
        </div>
        <div>
          <dl class="term_with_descr">
            <dt>{{'protocol.area' | trans}}:</dt>
            <dd>{{props.row.protocol.skillField.name}}</dd>
          </dl>
        </div>
      </div>

      <div slot="title" slot-scope="props">
  
        <router-link
            v-if="activeProtocolList(props.row.protocol.stages).length !== 1 &&
                  !isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                  !isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
                  !isPecsProtocol(props.row.protocol.teachingMethod.id) && !isCompleted(props.row) &&
                  !isNew(props.row) &&
                  !isMensurationForbidden  &&
                  !isClient &&
                  !isOnIndividualization(props.row)"
            :to="{ name: 'stage-list', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>

        <router-link
            v-if="isPecsWithDiscriminationProtocol(props.row.protocol.teachingMethod.id) &&
            !isCompleted(props.row) && !isNew(props.row) &&
            !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
            :to="{ name: 'stage-list', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
        <router-link v-if="activeProtocolList(props.row.protocol.stages).length === 1 && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) &&
          (isChainProtocol(props.row.protocol.teachingMethod.id) || isShapingProtocol(props.row.protocol.teachingMethod.id) || isMandProtocol(props.row.protocol.teachingMethod.id))"
                     :to="{ name: isChainProtocol(props.row.protocol.teachingMethod.id) ? 'chain-stage-current' : isShapingProtocol(props.row.protocol.teachingMethod.id) ? 'shaping-stage-current' : 'mand-stage-current',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
        <router-link v-if="activeProtocolList(props.row.protocol.stages).length === 1 && !isCompleted(props.row) && !isNew(props.row) &&
                     !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) && isUSDProtocol(props.row.protocol.teachingMethod.id)"
                     :to="{ name: 'choose-usd',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
        <router-link v-if="isPecsProtocol(props.row.protocol.teachingMethod.id) && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
                     :to="{ name: 'pecs-stage',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
        <router-link  v-if="isPecsWithoutDiscriminationProtocol(props.row.protocol.teachingMethod.id) && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
                                    :to="{ name: 'pecs-stage-without-discrimination',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}">
        <strong>{{props.row.protocol.title}}</strong>
      </router-link>

        <router-link  v-if="isPecsWithItemsProtocol(props.row.protocol.teachingMethod.id) && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row)"
                      :to="{ name: 'pecs-stage-items',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:props.row.protocol.stages[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
        <router-link v-if="props.row.protocol.stages.length === 1 && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) &&
          isUSDProtocol(props.row.protocol.teachingMethod.id)"
                     :to="{ name: 'choose-usd',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
        <router-link v-if="activeProtocolList(props.row.protocol.stages).length === 1 && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) &&
          isDTTProtocol(props.row.protocol.teachingMethod.id)"
                     :to="{ name: 'choose-stage',
                      params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
        <router-link v-if="activeProtocolList(props.row.protocol.stages).length === 1 && !isCompleted(props.row) && !isNew(props.row) &&
          !isMensurationForbidden  && !isClient && !isOnIndividualization(props.row) &&
          isSimpleProtocol(props.row.protocol.teachingMethod.id)"
                     :to="{ name: 'current-stage',
                     params: {clientId: clientId, protocolId: props.row.id, stageId:activeProtocolList(props.row.protocol.stages)[0].id}}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
  
  
        <router-link v-if="isNew(props.row) || (!isCompleted(props.row) && !isNew(props.row) && isMensurationForbidden)  ||
                      (!isCompleted(props.row) && !isNew(props.row) && isClient) || isOnIndividualization(props.row)"
                     :to="{ name: 'protocol-item', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>
        <router-link v-if="isCompleted(props.row)"
                     :to="{ name: 'results', params: {clientId: clientId, protocolId: props.row.id, teachingMethod: props.row.protocol.teachingMethod.id }}">
          <strong>{{props.row.protocol.title}}</strong>
        </router-link>

      </div>

      <div slot="status" slot-scope="props">
        <span class="status-badge"
              :class="{'new-status' : isNew(props.row),
                          'individualize-status' : isIndividualize(props.row),
                          'active-status' : isActive(props.row),
                          'maintaining-status' : isMaintaining(props.row),
                          'completed-status' : isCompleted(props.row)}">
                    </span>
        {{'protocol.statuses.' + props.row.status.name | trans}}
      </div>

      <div slot="action" slot-scope="props" v-if="!isTherapist && !isClient">
        <div>
          <mdc-menu-anchor>
            <mdc-button raised @click="props.row.isOpen = true">
              <i class="material-icons">more_vert</i></mdc-button>
            <mdc-menu v-model="props.row.isOpen">
              <mdc-menu-item  v-if="!isCompleted(props.row) && !isMensurationForbidden && !isPreviousDateSession" >
                <router-link class="nav-link"
                             :to="{ name: 'protocol-edit', params: {clientId: clientId, protocolId: props.row.protocol.id, clientProtocol: true, isActiveProtocol: isNew(props.row)}}">
                  {{'protocol.buttons.edit' | trans}}
                </router-link>
              </mdc-menu-item>
              <mdc-menu-item v-if="(isNew(props.row) || isOnIndividualization(props.row))&& !isMensurationForbidden">
              <a href="#" class="nav-link"
                 @click.prevent="showDeletePopup(props.row.id)">{{'protocol.buttons.delete'
                | trans}}</a>
            </mdc-menu-item>
              <mdc-menu-item>
                <a href="" class="nav-link"
                   @click.prevent="exportProtocol(props.row.protocol.id)">{{'protocol.buttons.export'
                  | trans}}</a>
              </mdc-menu-item>
              <mdc-menu-item>
                <a href="#" class="nav-link"
                   @click.prevent="makeFirst(props.row.id)">{{'protocol.make_first'
                  | trans}}</a>
              </mdc-menu-item>
              <mdc-menu-item>
                <a href="" class="nav-link"
                   @click.prevent="makeLast(props.row.id)">{{'protocol.make_last'
                  | trans}}</a>
              </mdc-menu-item>
              <mdc-menu-item v-if="isOnIndividualization(props.row)">
                <a href="" class="nav-link"
                   @click.prevent="allowMensuration(props.row.id)">{{'protocol.buttons.allow_mensuration'
                  | trans}}</a>
              </mdc-menu-item>
            </mdc-menu>
          </mdc-menu-anchor>
        </div>
      </div>

    </table-view>

    <div class="row mt-2 mt-md-3" v-if="!isTherapist && !onlyList && !isMensurationForbidden && !isPreviousDateSession">
      <div class="col-md-12 text-right">
        <mdc-button class="button-primary" raised
                    @click.prevent="onShowModalBtnClick">{{
          'protocol.buttons.addNewProtocol' | trans }}
        </mdc-button>
      </div>
    </div>

    <div v-if="isModalVisible">
      <new-protocol-modal v-if="isCurator || isBCBA"
                          :visible="isModalVisible"
                          :clientId="this.clientId"
                          v-on:close="onProtocolModalClose"
                          v-on:cancel="onModalCancel">
      </new-protocol-modal>
    </div>

    <mdc-dialog v-model="isDeleteModalVisible"
                :title="'user.confirm_delete' | trans"
                :accept="'user.delete' | trans"
                :cancel="'user.cancel' | trans"
                @accept="onRemoveActiveProtocol(assignedProtocolId)"
                @cancel="onModalClose">

    </mdc-dialog>

  </div>

</template>

<script>
  import axios from 'axios';
  import lang from '../../../../lang/translator';
  import isEmpty from 'lodash/isEmpty';
  import Loader from '../../../loader/components/Loader';
  import {pagination} from '../../../../common/mixins/pagination';
  import newProtocolModal from './ProtocolModal';
  import {showModal} from '../../../../common/mixins/showModal';
  import {mapActions, mapGetters} from 'vuex';
  import {PROTOCOL_STATUSES} from '../../../protocols/constants.js';
  import TableView from '../../../../common/table/components/TableView';
  import moment from 'moment';
  import filter from 'lodash/filter';
  import {typeProtocol} from '../../../../common/mixins/typeMethodProtocol';

  export default {
    name: 'ClientInfo',
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'onlyList': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'reload': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        protocolUrl: '/protocols/users/',
        assignedUrl: '/protocols/assigned/',
        assignedProtocols: [],
        isLoaded: true,
        isModalVisible: false,
        isDeleteModalVisible: false,
        assignedProtocolId: null,
        isChange: false,
        options: {
          pageHeader: 'assignedProtocols',
          initialPage: null,
          filterable: false,
          sortable: [],
          skin: 'table table-sm',
          withSearch: true,
          columns: [
            {
              key: 'id',
              changed: true,
              headings: lang.get('protocol.protocols')
            },
            {
              key: 'protocols',
              changed: true,
              headings: ''
            },
            {
              key: 'title',
              changed: true,
              headings: lang.get('protocol.protocols')
            },
            {
              key: 'status',
              changed: true,
              headings: lang.get('protocol.status')
            },
            {
              key: 'updatedAt',
              changed: false,
              headings: lang.get('protocol.change_date')
            },
            {
              key: 'action',
              changed: true,
              headings: ''
            }
          ],
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            console.info(resp);
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts:{
            filterPlaceholder: lang.get('bids.type_the_procol_name_to_search'),
            noResults:lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table')
          },
          columnsClasses:{
            id: 'action-cell',
            title: 'wide-col',
            protocols: 'wide-col',
            status: 'nowrap',
            updatedAt: 'text-center nowrap',
            action:'table-actions'
          },
          templates: {
            updatedAt: this.updatedAt,
          },
          toMomentFormat: ['updatedAt'],
          perPage: 10,
          columnsDisplay: {
            id: 'min_tabletL',
            updatedAt: 'min_tablet',
            protocols: 'min_tabletL',
            title: 'max_tabletP'
          }
        },
        search: '',
        searchSkillField: '',
        sort: '-position',
        errorDeleteMessage: null
      };
    },

    mixins: [pagination, showModal, typeProtocol],

    components: {
      Loader, newProtocolModal, TableView
    },

    computed: {
      isEmptyProtocols: function() {
        return isEmpty(this.assignedProtocols);
      },
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isTherapist',
        'isCurator',
        'isClient',
        'isBCBA',
        'isMensurationForbidden',
        'isPreviousDateSession'
      ]),
    },

    beforeDestroy(){
      localStorage.removeItem('currentPage');
    },

    methods: {


      activeProtocolList(stages){
        let activeList = filter(stages, stage => !stage.isClosed)

        return activeList;
      },

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      updatedAt(h, row) {
        return this.toLocaleDate(row.updatedAt.date);
      },

      async requestFunction (data) {
        return this.getAssignedProtocols(this.options.perPage, data.page, this.clientId, data.query);
      },

      isNew: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.NEW;
      },

      isActive: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.ACTIVE;
      },

      isIndividualize: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.INDIVIDUALIZATION;
      },


      isMaintaining: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.MAINTAINING;
      },

      isCompleted: function(protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.COMPLETED;
      },

      isDTT: function(protocol) {
        return protocol.protocol.teachingMethod.id === 1;
      },

      isSimple: function (protocol) {
        return protocol.protocol.teachingMethod.id === 2;
      },

      isMand: function(protocol) {
        return protocol.protocol.teachingMethod.id === 3;
      },

      isUSD: function (protocol) {
        return protocol.protocol.teachingMethod.id === 4;
      },

      isChain: function (protocol) {
        return protocol.protocol.teachingMethod.id === 5;
      },

      isShaping: function (protocol) {
        return protocol.protocol.teachingMethod.id === 6;
      },

      isPecs: function (protocol) {
        return protocol.protocol.teachingMethod.id === 7;
      },

      isOnIndividualization: function (protocol) {
        return protocol.status.id === PROTOCOL_STATUSES.INDIVIDUALIZATION;
      },

      onShowModalBtnClick(){
        this.isChange = false;
        this.isModalVisible = true;
      },

      getAssignedProtocols: async function(perPage, page, clientId, search) {
        try {
          this.isLoaded = false;
          localStorage.setItem('currentPage', page);
          localStorage.setItem('currentPageHeader', 'assignedProtocols');
          let params = {
              sort: this.sort,
              searchSkillField: search ? search.searchSkillField : this.searchSkillField,
              search: search ? search.search : this.search
          };

          let response = await axios.get(
              `${this.protocolUrl}${clientId}/${perPage}/${page}`, {
                params: params
              });

          let assignedProtocols = response.data.data.items;
          assignedProtocols.forEach(function(item) {
            item.isOpen = false;
          });
          this.assignedProtocols = assignedProtocols;
          this.isLoaded = true;
          if(response){
            this.isChange = false;
          }

          return response;
        } catch (error) {
          console.dir(error);
          this.$router.push({name: 'default'});
        }
      },

      exportProtocol: async function(id) {
        try {
          let response = await axios.get('/protocols/' + 'pdf/' + id,
              {responseType: 'blob'}).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', lang.get('protocol.protocol') + '_' +
                id + '.pdf');
            document.body.appendChild(link);
            link.click();
          });
        } catch (error) {
          console.dir(error);
        }
      },

      makeFirst: async function(id) {
        try {
          this.isChange = false;
          let response = await axios.post('/protocols/users/' + this.clientId + '/higher-position/' + id);
          if (response){
            this.isChange = true;
          }
        } catch (error) {
          console.dir(error);
        }
      },

      makeLast: async function(id) {
        try {
          this.isChange = false;
          let response = await axios.post('/protocols/users/' + this.clientId + '/lower-position/' + id);
          if (response){
            this.isChange = true;
          }
        } catch (error) {
          console.dir(error);
        }
      },
      allowMensuration: async function (id) {
        try {
          this.isChange = false;
          let response = await axios.post('/protocols/assigned/' +id + '/allow-mensuration');
          if (response){
            this.isChange = true;
          }
        } catch (error) {
          console.dir(error);
        }
      },
      showDeletePopup(id) {
        this.assignedProtocolId = id;
        this.isDeleteModalVisible = true;
        this.isChange = false;
      },

      onRemoveActiveProtocol: async function(protocolId) {
        try {
          this.isLoaded = false;

          let isDeleted = await axios.delete(this.assignedUrl + protocolId);
          if (isDeleted) {
            /*this.getAssignedProtocols(this.paginate.perPage, this.paginate.page,
                this.clientId);*/
            this.isLoaded = true;
            this.isChange = true;
          }

        } catch (error) {
          console.dir(error);
          this.isChange = false;
          if(error && error.status == 422){
            this.isChange = true;
            this.isLoaded = true;
            this.errorDeleteMessage = error.data.errors ? lang.get('protocol.unable_to_delete_protocol')  : error.data.message;
          }

        }
      },
      onProtocolModalClose() {
        this.isChange = false;
        this.onModalClose();
        let response = this.getAssignedProtocols(this.paginate.perPage, this.paginate.page,
            this.clientId);

        if (response){
          this.isChange = true;
        }
      },
      onSearchEnter: function (search) {
        this.search = search;
        this.paginate.page = 1;
      },

      onSearchSkillField: function (searchSkillField) {
        this.searchSkillField = searchSkillField;
        this.paginate.page = 1;
      },
    },
    watch: {
      reload: function(newVal) {
        if (newVal) {
          this.isChange = false;
          let response = this.getAssignedProtocols(this.paginate.perPage, this.paginate.page,
              this.clientId);

          if (response){
            this.isChange = true;
          }
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/client/components/AssignedProtocolList.vue